//SeededFile-FileSeedingForNPeers-Fill x Toast

import React from 'react';

import MuiAlert  from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';

export const SeedSuccessToast = function SeedSuccessToast( { open, closeSnack } ){

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    var handleClose = () => {

        closeSnack();

    }

    return(
        <Snackbar anchorOrigin={{ vertical : 'top', horizontal : 'center' }} open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="success">
                File seeding completed!
            </Alert>
        </Snackbar>
    )

}

export const FileSeedingStatusToast = function FileSeedingStatusToast( { fileCount, peerCount, show, closeSnack } ) {

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    var handleClose = () => {
    
        closeSnack();

    }

    return(
        <Snackbar anchorOrigin={{ vertical : 'top', horizontal : 'center' }} open={show} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="success">
                { fileCount + " file(s) seeding amongst " + peerCount + " peer(s)."} 
            </Alert>
        </Snackbar>
    )

}

export const SuccessToast = function SuccessToast({ open, message, closeSnack }) {

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    var handleClose = () => {

        closeSnack();

    }

    return(
        <Snackbar anchorOrigin={{ vertical : 'top', horizontal : 'center' }} open={open} autoHideDuration={5000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="success">
                { message }
            </Alert>
        </Snackbar>
    )

}

export const InputViolationToast = function InputViolationToast( { open, errorText ,closeSnack } ){
    
    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    var handleClose = () => {

        closeSnack();

    }

    return(
        <Snackbar anchorOrigin={{ vertical : 'top', horizontal : 'center' }} open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="error">
                { errorText }
            </Alert>
        </Snackbar>
    )

}